<script>
    import { createEventDispatcher } from "svelte";
    import { colorPalette } from "../../stores/profile.js";
    import windows from "../../stores/windows.js";

    export let window;

    const dispatch = createEventDispatcher();

    function didPickColor(color) {
        dispatch("select", { color });

        windows.close(window.id);
    }
</script>

<div class="picker">
    {#each colorPalette as color}
        <div style={`background: ${color}`}>
            <div
                role="button"
                tabindex="-1"
                on:click={() => didPickColor(color)}
                on:keydown={() => {}}
                on:keyup={() => {}}
                on:keydown={() => didPickColor(color)}
            />
        </div>
    {/each}
</div>

<style>
    .picker {
        display: flex;
        flex-wrap: wrap;
    }

    .picker > div {
        flex: 1 0 25%;
        aspect-ratio: 189/167;
    }

    .picker > div div {
        opacity: 0.25;
        box-sizing: border-box;
        border: #999999 3px outset;
        width: 100%;
        height: 100%;
    }

    .picker > div div:active {
        opacity: 0.5;
        border: #000000 3px inset;
        background: rgba(0, 0, 0, 0.75);
    }
</style>
